import { FC } from 'react';
import { ButtonToggle, Flex } from '@servicetitan/anvil2';

interface YesNoButtonProps {
    onYes: () => void;
    onNo: () => void;
}

export const YesNoButton: FC<YesNoButtonProps> = ({ onYes, onNo }) => {
    return (
        <Flex gap="2">
            <ButtonToggle onClick={onYes}>Yes</ButtonToggle>
            <ButtonToggle onClick={onNo}>No</ButtonToggle>
        </Flex>
    );
};
